<script>
  import Icon from 'svelte-awesome';
  import {home, cog, mobile, user} from 'svelte-awesome/icons';
  import {link} from 'svelte-spa-router'
</script>

<style>
    #sidebar {
        transition: ease-in-out all .3s;
        z-index: 9999;
    }

    #sidebar span {
        opacity: 0;
        position: absolute;
        transition: ease-in-out all .1s;
    }

    #sidebar:hover {
        width: 150px;
        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
        /*shadow-2xl*/
    }

    #sidebar:hover span {
        opacity: 1;
    }
</style>

<div id="sidebar" class="h-screen w-16 menu bg-white text-white px-4 flex items-start nunito static fixed shadow">

    <ul class="">
        <li class="mt-4">
            <div class="my-2 md:my-0 py-1 md:py-3 pl-1 align-middle text-gray-500 no-underline hover:text-indigo-400">
                <Icon data={user} class="text-blue-500 font-black text-center w-5 mr-3"/>
                <span class="w-full inline-block pb-1 md:pb-0 text-sm">Logout</span>
            </div>
        </li>
        <li class="mt-16">
            <ul class="list-reset">
                <li class="my-2 md:my-0">
                    <a use:link={"/"}
                       class="block py-1 md:py-3 pl-1 align-middle text-gray-600 no-underline hover:text-indigo-400">
                        <Icon data={home} class="font-black text-center w-5 mr-3"/>
                        <span class="w-full inline-block pb-1 md:pb-0 text-sm">Home</span>
                    </a>
                </li>
                <li class="my-2 md:my-0 ">
                    <a use:link={"/apps"}
                       class="block py-1 md:py-3 pl-1 align-middle text-gray-600 no-underline hover:text-indigo-400">
                        <Icon data={mobile} class="font-black text-center w-5 mr-3"/>
                        <span class="w-full inline-block pb-1 md:pb-0 text-sm">Apps</span>
                    </a>
                </li>
                <li class="my-2 md:my-0 ">
                    <a use:link={"/settings"}
                       class="block py-1 md:py-3 pl-1 align-middle text-gray-600 no-underline hover:text-indigo-400">
                        <Icon data={cog} class="font-black text-center w-5 mr-3"/>
                        <span class="w-full inline-block pb-1 md:pb-0 text-sm">Settings</span>
                    </a>
                </li>
            </ul>
        </li>
    </ul>


</div>

